import React from 'react';

const CardBadge = ({ label = '熱門影片' }) => (
  //     display: inline-flex;
  // height: 26px;
  // padding: 2px 10px;
  // justify-content: center;
  // align-items: center;
  // gap: 12px;
  // flex-shrink: 0;
  (<span
    style={{
      display: 'inline-flex',
      height: 26,
      padding: '2px 10px 2px 10px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 12,
      flexShrink: 0,
      background: '#FFE9E7',
      color: '#F21A1A',
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: '150%',
      borderRadius: 6
    }}
  >
    {label}
  </span>)
);

export default CardBadge;
